import { inject, type InjectionKey } from "vue";
import { PaymentProviderName, type PaymentConfig } from "@/lib/config";
import { AdyenPaymentProvider } from "./providers/adyen";
import { MockPaymentProvider } from "./providers/mock";
import { StripePaymentProvider } from "./providers/stripe";
import type { PaymentProvider } from "./types";

export const paymentProviderKey: InjectionKey<PaymentProvider> =
  Symbol("payment-provider");

export function usePaymentProvider(): PaymentProvider {
  const provider = inject(paymentProviderKey);
  if (!provider) {
    throw new Error(
      "Payment provider not installed. Did you forget app.provide(paymentProviderKey, ...) in main.ts?",
    );
  }
  return provider;
}

export function createPaymentProvider(config: PaymentConfig): PaymentProvider {
  switch (config.provider) {
    case PaymentProviderName.Adyen:
      return new AdyenPaymentProvider(config.environment);
    case PaymentProviderName.Stripe:
      return new StripePaymentProvider();
    case PaymentProviderName.Mock:
      return new MockPaymentProvider();
    default:
      throw new Error(`Unknown payment provider: ${String(config.provider)}`);
  }
}
